import { Tooltip } from 'antd'
import { HTMLAttributes, Ref } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons'
import { JobListItem } from '../JobList/jobListItem'
import { centsToDollarsDisplay } from '../displayFormatters'
import { avatarColourFor, initialsOf } from './jobKanbanModel'

type Props = {
  job: JobListItem
  accent: string
  innerRef?: Ref<HTMLElement>
  dragging?: boolean
  overlay?: boolean
  condensed?: boolean
} & HTMLAttributes<HTMLElement>

const JobKanbanCard = ({ job, accent, innerRef, dragging, overlay, condensed, className, style, ...rest }: Props) => {
  const open = () => { window.location.href = `#!/${job.url}` }

  const classNames = ['job-kanban__card']
  if (dragging) {
    classNames.push('job-kanban__card--dragging')
  }
  if (overlay) {
    classNames.push('job-kanban__card--overlay')
  }
  if (condensed) {
    classNames.push('job-kanban__card--condensed')
  }
  if (className) {
    classNames.push(className)
  }

  return <article
    ref={innerRef}
    className={classNames.join(' ')}
    style={{ borderInlineStartColor: accent, ...style }}
    role="button"
    tabIndex={0}
    aria-label={job.name}
    onClick={open}
    onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        open()
      }
    }}
    {...rest}
  >
    {!condensed && <div className="job-kanban__card-top">
      <span className="job-kanban__card-number">{job.jobNumber}</span>
      <span className="job-kanban__card-price">{centsToDollarsDisplay(job.finalPrice)}</span>
    </div>}

    <div className="job-kanban__card-headline">
      <h4 className="job-kanban__card-name">{job.name}</h4>
      {condensed && <span className="job-kanban__card-price">{centsToDollarsDisplay(job.finalPrice)}</span>}
    </div>

    {!condensed && <div className="job-kanban__card-customer">{job.customer}</div>}

    {job.property && <div className="job-kanban__card-property">
      <FontAwesomeIcon icon={faLocationDot} className="job-kanban__card-pin" />
      <span>{job.property}</span>
    </div>}

    {!condensed && job.salesPerson && <div className="job-kanban__card-foot">
      <Tooltip title={job.salesPerson}>
        <span
          className="job-kanban__avatar"
          style={{ backgroundColor: avatarColourFor(job.salesPerson) }}
          aria-label={job.salesPerson}
        >
          {initialsOf(job.salesPerson)}
        </span>
      </Tooltip>
      <span className="job-kanban__card-sales">{job.salesPerson}</span>
    </div>}
  </article>
}

export default JobKanbanCard
